import React from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faMoneyBillTrendUp,
  faChartPie,
  faChartArea,
  faChartSimple,
} from "@fortawesome/free-solid-svg-icons";

const StockQuoteCard = (stockData) => {
  if (!stockData.symbol)
    return <>Failed to get this message!</>;

  return (
    <>
      <Card
        className="shadow-lg"
        style={{
          backgroundImage: "linear-gradient(to top, #182b1e 0%, #0f383e 1%, #205c64 100%)",
          color: "#d9d9d9",
          borderRadius: "12px",
          maxWidth: "50%"
        }}
      >
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h4><FontAwesomeIcon icon={faChartSimple}  /> {stockData.symbol}</h4>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <div className="mb-3">
                <FontAwesomeIcon icon={faMoneyBillTrendUp} className="me-2" />
                <strong>LTP:</strong> ${stockData.current_price || stockData.price}
              </div>
              <div className="mb-3">
                <FontAwesomeIcon icon={faChartPie} className="me-2" />
                <strong>Market Cap:</strong> {stockData.market_cap}
              </div>
            </Col>
            <Col>
              <div className="mb-3">
                <strong>52-Week High:</strong> ${stockData.fifty_two_week_high}
              </div>
              <div className="mb-3">
                <strong>52-Week Low:</strong> ${stockData.fifty_two_week_low}
              </div>
            </Col>
          </Row>
          <hr className="my-3" />
          <Card.Text>
            <strong>Analysis:</strong> {stockData.analysis_summary}
          </Card.Text>
        </Card.Body>
        <Card.Footer className="text-center">
          <small>Last updated: {stockData.timestamp}</small>
        </Card.Footer>
      </Card>
      <br />
      <Row>
        <Container>
          <Card.Text>
            <h6>Sources:</h6>
            <ol>
              {stockData.citations &&
                stockData.citations.map((c, i) => {
                  return (
                    <li key={i.toString()}>
                      <img
                        height="16"
                        width="16"
                        src={`http://www.google.com/s2/favicons?domain=${c}`}
                      />
                      <a
                        style={{
                          fontSize: "0.8em",
                          color: "#bfbfbd",
                          margin: "2px 2px",
                        }}
                        href={c}
                        target="_blank"
                      >
                        {c}
                      </a>
                      <br />
                    </li>
                  );
                })}
            </ol>
          </Card.Text>
        </Container>
      </Row>
    </>
  );
};

export default StockQuoteCard;
